// @charset "utf-8";
/* eslint-disable */
/*
 * 点击元素外面触发事件
 * e.g. <div v-auth-dom="ref"></div>
 *
 */
import store from './../store'
import authList from './_authList'

var domCache = {};

export default {
    async bind (el, binding, vnode) {
        const authKey = binding.arg
        if (authKey in domCache) {
            el.style.display = domCache[authKey]
            return
        }

        const oldValue = el.style.display
        el.style.display = 'none'
        let role = await store.getters['userInfo/userRole']
        if (role === null) {
            el.remove()
        } else if (role === 0) {
            el.style.display = oldValue
        } else {
            if (role in authList) {
                if (authList[role].indexOf(authKey) >= 0) {
                    el.style.display = oldValue
                } else {
                    el.remove()
                }
            } else {
                el.remove()
            }
        }

        domCache[authKey] = el.style.display
    },
    update (el, binding) {

    },
    unbind (el) {

    }
}



// WEBPACK FOOTER //
// ./src/lib/authDom.js